import { protectedApi } from 'services/axios';
import serviceUrl from 'services/serviceUrlList';

export const createBlogCategory = async payload => {
  try {
    const response = await protectedApi.post(
      serviceUrl.content.blogCategory.list,
      payload
    );
    return response;
  } catch (error) {
    return error.response;
  }
};
export const updateBlogCategory = async (payload, id) => {
  try {
    const response = await protectedApi.put(
      serviceUrl.content.blogCategory.detail + id,
      payload
    );
    return response;
  } catch (error) {
    return error.response;
  }
};
